import { render, staticRenderFns } from "./variableearningsIntro.vue?vue&type=template&id=0a29d37a&scoped=true"
import script from "./variableearningsIntro.vue?vue&type=script&lang=js"
export * from "./variableearningsIntro.vue?vue&type=script&lang=js"
import style0 from "./variableearningsIntro.vue?vue&type=style&index=0&id=0a29d37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a29d37a",
  null
  
)

export default component.exports